(() => {
  const initialized = new WeakSet();

  const rootPath = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : `${root}/`;
  };

  const hideSingleNativeColor = (root) => {
    const productRoot = root.closest('product-info') || root.closest('.product') || document;
    productRoot.querySelectorAll('variant-selects fieldset').forEach((fieldset) => {
      const legend = fieldset.querySelector('legend')?.textContent?.trim().toLowerCase();
      const choices = fieldset.querySelectorAll('input[type="radio"], option').length;
      if (legend === 'color' && choices <= 1) {
        fieldset.hidden = true;
        fieldset.setAttribute('aria-hidden', 'true');
        fieldset.dataset.okLinkedColorReplaced = 'true';
      }
    });
  };

  const optionButton = (entry, currentHandle) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'ok-linked-product-picker__option';
    if (!entry.a) button.classList.add('ok-linked-product-picker__option--sold-out');
    button.setAttribute('aria-current', String(entry.h === currentHandle));
    button.setAttribute('aria-label', `${entry.c}${entry.a ? '' : ' — Sold out'}`);
    button.title = `${entry.c}${entry.a ? '' : ' — Sold out'}`;

    const label = document.createElement('span');
    label.className = 'ok-linked-product-picker__label';
    label.textContent = entry.c;
    button.append(label);
    button.addEventListener('click', () => {
      if (entry.h === currentHandle) return;
      window.location.assign(`${rootPath()}products/${encodeURIComponent(entry.h)}`);
    });
    return button;
  };

  const initialize = (root) => {
    if (initialized.has(root)) return;
    initialized.add(root);
    const data = window.StoreForgeOluKaiLinkedProducts;
    const currentHandle = root.dataset.currentHandle;
    const groupIndex = data?.byHandle?.[currentHandle];
    const items = Number.isInteger(groupIndex) ? data.groups?.[groupIndex]?.items : null;
    if (!Array.isArray(items) || items.length < 2) return;
    const current = items.find((entry) => entry.h === currentHandle);
    if (!current) return;

    const legend = document.createElement('p');
    legend.className = 'ok-linked-product-picker__legend';
    legend.append('Color: ');
    const value = document.createElement('span');
    value.className = 'ok-linked-product-picker__value';
    value.textContent = current.c;
    legend.append(value);
    const options = document.createElement('div');
    options.className = 'ok-linked-product-picker__options';
    options.setAttribute('role', 'list');
    items.forEach((entry) => options.append(optionButton(entry, currentHandle)));
    root.append(legend, options);
    root.hidden = false;
    hideSingleNativeColor(root);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-ok-linked-product-picker]').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
